import { dynamicI18n } from 'features/i18n/DynamicTranslation/dynamicI18n';
import { logger } from 'features/logger/logger';
import type { AppPromiseThunk } from 'features/store/store';

export const loadDynamicTranslationNamespaces =
  (namespaces: string[]): AppPromiseThunk =>
  async () => {
    try {
      logger.info(
        `Loading dynamic translation namespaces: ${namespaces.join(', ')}`
      );
      await dynamicI18n.loadNamespaces(namespaces);
    } catch (error) {
      logger.error(
        `Unable to load dynamic translation namespaces: ${namespaces.join(', ')}`,
        undefined,
        error as Error
      );
    }
  };
